import { Component, OnInit, WritableSignal, signal, inject } from '@angular/core';
import { Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { SelectModule } from 'primeng/select';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';
import {StandardDropdown} from '../../../../shared/models/components/dropdowns/standardDropdown.models';
import { DividerModule } from 'primeng/divider';
import { DatePickerModule } from 'primeng/datepicker';
import { TextareaModule } from 'primeng/textarea';
import { RadioButtonModule  } from 'primeng/radiobutton';
    // let closingTradeData: closingTradeData | undefined = currentFeedback?.closingTradeData;
import { givenFeedbackModel,givenFeedbackField,  runsDataByUserRequest, currentFeedbackModel, openTradeData, predictionData, closingTradeData } from '../../../../shared/models/serviceModels/request/feedbackReq.model';
import { feedbackFormsData, feedbackDataSetValues } from '../../../../shared/models/serviceModels/response/feedbackRes.model';
import { FeedbackService } from '../../../../shared/services/componentsServices/feedback.service';
import { UserProfileStore } from '../../../../shared/store/user-profile.store';
import { SharedDataService } from '../../../../shared/services/componentsServices/shared-data.service';

import { LoadingButtonComponent } from '../../../../shared/components/loading-button/loading-button.component';

import { ConfirmationModuleComponent } from './confirmation-module/confirmation-module.component';

import { InitiateTradeFormComponent } from './forms/initiate-trade-form/initiate-trade-form.component';
import { CloseTradeFormComponent } from './forms/close-trade-form/close-trade-form.component';
import { MarketEventsFormComponent } from './forms/market-events-form/market-events-form.component';
import { ModelDirectionsFormComponent } from './forms/model-directions-form/model-directions-form.component';
import { OpenCloseFormComponent } from './forms/open-close-form/open-close-form.component';
import { OthersFormComponent } from './forms/others-form/others-form.component';

import { faCircle } from '@fortawesome/free-solid-svg-icons';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';

@Component({
    selector: 'app-feedback',
    standalone: true,
    imports: [SelectModule,
        FormsModule,
        CommonModule,
        FontAwesomeModule,
        DividerModule,
      DatePickerModule,
      TextareaModule,
        RadioButtonModule,
        InitiateTradeFormComponent,
        CloseTradeFormComponent,
        ConfirmationModuleComponent,
        MarketEventsFormComponent,
        ToastModule,
        LoadingButtonComponent,
        ModelDirectionsFormComponent,
        OpenCloseFormComponent,
        OthersFormComponent
    ],
    providers: [MessageService],
    templateUrl: './feedback.component.html',
    styleUrl: './feedback.component.scss'
})
export class FeedbackComponent implements OnInit {

  private userProfileStore = inject(UserProfileStore);
  private messageService = inject(MessageService);
  private router = inject(Router);
  private feedbackService = inject(FeedbackService);
  private sharedDataService = inject(SharedDataService);

  constructor(
    library: FaIconLibrary
  ) {
    library.addIconPacks(fas);

  }

  isSpinnerVissible = signal(false);
 
  faCircle = faCircle;
  userProfile = this.userProfileStore.userProfile();
  isRoleDropdownDisabled = false;

  private givenFeedbackResponse: currentFeedbackModel = { feedbackFields: [], userId: "", userRoleId: 0, feedbackDate: new Date(), feedbackTypeId: 1 };
   
  userId: string = ""; //to be replaced with logged in user
  userRoleId: number = 1; //to be replaced with logged in user

  rolesDropdown:  WritableSignal<StandardDropdown[]>  = signal([]);
  selectedRole: StandardDropdown= {description: "", value: ""};
  
  feedbackTypeDropdown:  WritableSignal<StandardDropdown[]>  = signal([]);

  selectedFeedbackType: StandardDropdown= {description: "", value: ""};

  feedbackType_initiateTrade: WritableSignal<string> = signal("1");
  feedbackType_closeTrade: WritableSignal<string> = signal("2");
  feedbackType_initiateAndCloseTrade: WritableSignal<string> = signal("3");
  feedbackType_modelDirection: WritableSignal<string> = signal("4");
  feedbackType_marketEvents: WritableSignal<string> = signal("5");
  feedbackType_other: WritableSignal<string> = signal("6");
  isConfirmationModalOpen= signal(false);
  isFormdataLoading = true;

 
  ngOnInit(): void {
    this.feedbackService.resetFeedbackValues();
    this.feedbackService.setAreMandatoryFieldsLoaded(false);
    
    
    this.setUserBasicData();
    this.getFormsDataFromService();

  }

 
  mapFormsTypes() {
    let dropdowns = this.feedbackTypeDropdown();

    // this.feedbackType_initiateTrade.set(dropdowns.find(item => item.description.toLowerCase() === 'initiate trade')?.value || "1");
    // this.feedbackType_closeTrade.set(dropdowns.find(item => item.description.toLowerCase() === 'close trade')?.value || "2");
    // this.feedbackType_initiateAndCloseTrade.set(dropdowns.find(item => item.description.toLowerCase() === 'initiate and close trade')?.value || "3");
    // this.feedbackType_modelDirection.set(dropdowns.find(item => item.description.toLowerCase() === 'model direction')?.value || "4");
    // this.feedbackType_marketEvents.set(dropdowns.find(item => item.description.toLowerCase() === 'market events')?.value || "5");

    this.feedbackType_initiateTrade.set(dropdowns.find(item => item.field?.toLowerCase().trim() === 'initiate'.trim())?.value || "1");
    this.feedbackType_closeTrade.set(dropdowns.find(item => item.field?.toLowerCase().trim() === 'close'.trim())?.value || "2");
    this.feedbackType_initiateAndCloseTrade.set(dropdowns.find(item => item.field?.toLowerCase().trim() === 'initiate_close'.trim())?.value || "3");
    this.feedbackType_modelDirection.set(dropdowns.find(item => item.field?.toLowerCase().trim() === 'model'.trim())?.value || "4");
    this.feedbackType_marketEvents.set(dropdowns.find(item => item.field?.toLowerCase().trim() === 'market'.trim())?.value || "5");
    this.feedbackType_other.set(dropdowns.find(item => item.field?.toLowerCase().trim() === 'other'.trim())?.value || "6");
  }

  mapDropdown(dropdownValues: feedbackDataSetValues[], dropdownName: string = ""): StandardDropdown[] {

    let mappedDropdown: StandardDropdown[] = [];

    switch(dropdownName){
      
      case 'roles':
        mappedDropdown = dropdownValues.map(item => ({
          description: (item.field || '').trim(),
          value: (item.id?.toString() || '').trim()
        }));
        break;

      case 'feedbackType':
        mappedDropdown = dropdownValues.map(item => {
          const description = (item.description || '').trim();
          const value = item.id?.toString() || '';
          const field = (item.field || '').trim();
          let selectorId = '';

          switch (field.toLowerCase()) {
            case 'initiate':
              selectorId = "1";
              break;
            case 'close':
              selectorId = "2";
              break;
            case 'initiate_close':
              selectorId = "3";
              break;
            case 'model':
              selectorId = "4";
              break;
            case 'market':
              selectorId = "5";
              break;
            case 'other':
              selectorId = "6";
              break;
            default:
              selectorId = '';
              break;
          }

          return { description, value, field, selectorId };
        });
      break;
      default:
        mappedDropdown = dropdownValues.map(item => ({
          description: item.field || '',
          value: item.id?.toString() || ''
        }));
        break;
    }
   

    return mappedDropdown;

  }

  mapDropDownsFromService(data: feedbackFormsData){

    if(data.errorMsg){
      //show error
      return;
    }

    if(data.rolesList){

      let rolesData= data.rolesList;

      if(rolesData.errorMsg){
        //show error
        return;
      }

      let mappedValues = this.mapDropdown(rolesData.feedbackFieldValues || [], 'roles');

      this.rolesDropdown.set(mappedValues);

    };

    if(data.feedbackType){

      let feedbackTypeData= data.feedbackType;

      if(feedbackTypeData.errorMsg){
        //show error
        return;
      }

      let mappedValues = this.mapDropdown(feedbackTypeData.feedbackFieldValues || [], 'feedbackType');


      this.feedbackTypeDropdown.set(mappedValues);
    };

    if(data.feedbackFields){

      let feedbackFieldsData= data.feedbackFields;

      if(feedbackFieldsData.errorMsg){
        //show error
        return;
      }
    };



  }

  setUserBasicData(){
    let userId= this.userProfile?.email?.toLowerCase() || "";
    this.userId= userId;

    let userRol = this.userProfile?.roleId || 1;
    this.userRoleId= userRol;
  }

  getFormsDataFromService() {
    let userId = this.userId;
    let feedbackFormRequest = { userId: userId.toString() };
    let getRunsDataByUserRequest = this.mapGetRunsByUserEmailRequest();

    // Execute both requests in parallel for better performance
    forkJoin({
      formData: this.feedbackService.getFeedbackFormData(feedbackFormRequest),
      runsData: this.feedbackService.getPredictionsByUser(getRunsDataByUserRequest)
    }).subscribe({
      next: ({ formData, runsData }) => {
        this.feedbackService.setFormData(formData);
        this.feedbackService.setRunsDataByUser(runsData);
        this.mapServicesResults();
      },
      error: (error) => {
        console.error('Error loading feedback data:', error);
        this.isFormdataLoading = false;
      }
    });
  }

  mapServicesResults(){

    let formData = this.feedbackService.getFormData();

    this.mapDropDownsFromService(formData()!);
    this.setDefaultValuesForUi();

    this.mapFormsTypes();
    this.isFormdataLoading = false;

    this.setDefaultValues();
  }


  mapGetRunsByUserEmailRequest(): runsDataByUserRequest{
    let respose:runsDataByUserRequest={};

    respose.userEmail= this.userId;

    return respose;
  }


  mapGetRunDataByRundId():runsDataByUserRequest{
    let respose:runsDataByUserRequest={};
    respose.runId= '0';

    return respose;
  }

  setDefaultValuesForUi(){
    let selectedRole = this.rolesDropdown().find(item => item.value === this.userRoleId.toString()) || { description: "", value: "" };
    this.selectedRole = selectedRole;

    this.isRoleDropdownDisabled = true;

    let selectedFeedbackType = this.feedbackTypeDropdown().find(item => item.selectorId === "1") || { description: "", value: "" };
    this.selectedFeedbackType = selectedFeedbackType;

  }

  setDefaultValues(){
    let feedbackTypeId = +this.selectedFeedbackType.value || 1;
    
    this.givenFeedbackResponse = { feedbackFields: [], userId: this.userId, userRoleId: this.userRoleId, feedbackDate: new Date(), feedbackTypeId: feedbackTypeId};

    this.feedbackService.setFeedbackValues(this.givenFeedbackResponse!);
  }


  setSelectedValue(selectedValue:string, type?: string){

    switch(type){

      //role should not be editable except by super admins
      case 'role':
        let selectedRole: StandardDropdown= this.rolesDropdown().find(item=> item.value===selectedValue) || this.selectedRole;
        this.selectedRole= selectedRole;

        this.givenFeedbackResponse.userRoleId = +selectedRole.value;

      
        this.feedbackService.setFeedbackValues(this.givenFeedbackResponse!);
        break;
      case 'type':
        let selectedType: StandardDropdown= this.feedbackTypeDropdown().find(item=> item.value===selectedValue) || this.selectedFeedbackType;

        this.selectedFeedbackType= selectedType;  

        this.givenFeedbackResponse.feedbackTypeId = +selectedType.value;
        
        this.feedbackService.setFeedbackValues(this.givenFeedbackResponse!);

        
        break;

      default:
        break
    }

  }


  onUserRoleChange(event: any) {
    
    this.setSelectedValue(event.value, "role");
    // this.setDataForBenchmark();

  }

  onFeedbackTypeChange(event: any) {

    this.feedbackService.resetFeedbackValues();
    this.feedbackService.setAreMandatoryFieldsLoaded(false);

    this.setDefaultValues();

    this.setSelectedValue(event.value, "type");
    let selectedFeedbackType: StandardDropdown = event.value;
    this.feedbackService.setSelectedFeedbackType(selectedFeedbackType);
   
   
  }



  onSubmitForm(){
    let currentFeedback = this.feedbackService.getFeedbackBeforeSubmit();

    //if form is incomplete, button is disabled. This is second control

    if (!currentFeedback) {
      throw new Error('Feedback data is null');
    }

    this.isConfirmationModalOpen.set(true);
   
  }

  mapCurrentFeedbackToGivenFeedback(): givenFeedbackModel {
    let currentFeedback = this.feedbackService.getFeedbackBeforeSubmit();

    let feedbackFields: givenFeedbackField[] = this.mapFeedbackFields(currentFeedback?.feedbackFields || []);
    let openTradeData: openTradeData | undefined = currentFeedback ? this.mapOpenTradeData(currentFeedback) : undefined;
    let predictionData: predictionData | undefined = currentFeedback ? this.mapPredictionData(currentFeedback) : undefined;
    let closingTradeData: closingTradeData | undefined = currentFeedback?.closingTradeData;

    let givenFeedback: givenFeedbackModel = {
      userId: currentFeedback?.userId || "",
      userRoleId: currentFeedback?.userRoleId || 1,
      feedbackDate: currentFeedback?.feedbackDate || new Date(),
      feedbackTypeId: currentFeedback?.feedbackTypeId || 1,
      feedbackFields: feedbackFields,
      // openTradeData: openTradeData,
      // predictionData: predictionData
    };

    if(openTradeData?.contract!== undefined){
    // if(openTradeData && Object.keys(openTradeData).length > 0){
      givenFeedback.openTradeData= openTradeData;
    }

    if(predictionData?.predictionCaseId !== undefined || predictionData?.predictionRunId !== undefined){

    // if(predictionData?.predictionRunId !== undefined || predictionData?.predictionCaseId !== undefined){
    // if(predictionData && Object.keys(predictionData).length > 0){
      givenFeedback.predictionData= predictionData;
    } 

    if(closingTradeData?.closingDate !== undefined){
    // if(closingTradeData?.openTradeId !== undefined){
    // if(closingTradeData && Object.keys(closingTradeData).length > 0){
      givenFeedback.closingTradeData= closingTradeData;
    } 

    return givenFeedback;
  }

  mapFeedbackFields(feedbackFiedlds: givenFeedbackField[]): givenFeedbackField[]{
    let mappedFields: givenFeedbackField[] = [];
    feedbackFiedlds.forEach(item=>{
      //fieldname
     
      if(item.fieldName.toLowerCase() === 'free_text'){
        mappedFields.push(item);
      }

    });

    return mappedFields;
  }

  mapOpenTradeData(currentFeedback: currentFeedbackModel): openTradeData{

    const contractField = currentFeedback.feedbackFields.find(item => item.fieldName === "contract");
    const directionField = currentFeedback.feedbackFields.find(item => item.fieldName === "direction");
    const entryPriceField = currentFeedback.feedbackFields.find(item => item.fieldName === "trade_price");
    const lotsField = currentFeedback.feedbackFields.find(item => item.fieldName === "lots");
    const tradeDateField = currentFeedback.tradeDate;


    let openTradeData: openTradeData= {
        contract: contractField?.value,
        directionId: directionField?.fieldId ? +directionField.fieldId : undefined,
        entryPrice: entryPriceField?.value ? +entryPriceField.value : undefined,
        lots: lotsField?.value ? +lotsField.value : undefined,
        tradeDate: tradeDateField ? new Date(tradeDateField) : undefined
    };

    return openTradeData;
  }

  mapPredictionData(currentFeedback: currentFeedbackModel): predictionData{

    let predictionCaseData= currentFeedback?.feedbackFields?.find(item => item.fieldName === "scenario");
    let scenarioNameData= currentFeedback?.feedbackFields?.find(item => item.fieldName === "scenario_name");


    let predictionRunId= currentFeedback.predictionRunId;
    let predictionUpdateDate= currentFeedback.predictionUpdateDate;
    let predictionRunDate= currentFeedback.predictionRunDate;
    let predictionSourceTypeId= currentFeedback.predictionSourceTypeId;

    let predictionCaseId = predictionCaseData?.value ? +predictionCaseData.value : undefined;
    let predictionCaseName= predictionCaseData?.extraDescription ? predictionCaseData.extraDescription : undefined;
    let scenarioName = scenarioNameData?.value ? scenarioNameData.value : undefined;
    let predictedPriceField = currentFeedback.feedbackFields.find(item => item.fieldName === "predicted_price");

    let predictionData: predictionData= {
        predictionRunId: predictionRunId,
        predictionUpdateDate: predictionUpdateDate,
        predictionRunDate: predictionRunDate,
        predictionSourceTypeId: predictionSourceTypeId,
        predictionCaseId: predictionCaseId,
        predictionCaseName: predictionCaseName,
        scenarioName: scenarioName,
        predictedPrice: predictedPriceField?.value ? +predictedPriceField.value : undefined
    };
    return predictionData;

  }

  
  closeConfirmationModal(){
    this.isConfirmationModalOpen.set(false);
  }

  confirmSubmit(){
    let givenFeedback: givenFeedbackModel = this.mapCurrentFeedbackToGivenFeedback();
    this.isConfirmationModalOpen.set(false);
    this.isSpinnerVissible.set(true);
    this.feedbackService.setFieldsStatus(true);

    this.feedbackService.sendFeedback(givenFeedback).subscribe({
      next: (data) => {
        this.isSpinnerVissible.set(false);
        this.feedbackService.setFieldsStatus(false);

        if(data.isSuccess===false){
          this.messageService.add({ severity: 'error', summary: 'Your feedback could not been saved.', detail: 'Try again later or contact your supervisor.', life: 3000 });
     
          throw new Error('Feedback submission failed');

        }
        //if ok, show ok message
        this.messageService.add({ severity: 'success', summary: 'Feedback saved', detail: 'Your feedback has been successfully saved.', life: 3000 });
        this.feedbackService.resetFeedbackValues();
        
        setTimeout(() => {
          this.sharedDataService.setActiveTab(0);
          this.router.navigate(['/model-predictions']);
        }, 3000);

      },
      error: (error) => { 
        this.isSpinnerVissible.set(false);
        this.feedbackService.setFieldsStatus(false);
        
        this.messageService.add({ severity: 'error', summary: 'Your feedback could not been saved.', detail: 'Try again later or contact your supervisor.', life: 3000 });
     
      }
    });

  }

  

  isSubmitButtonDisabled():boolean{

    let areMandatoryFieldsLoaded = this.feedbackService.getAreMandatoryFieldsLoaded();

    return !areMandatoryFieldsLoaded;
  }
 
}
